import { LoadableAfterPaint } from '@confluence/loadable';

export const PageIncludeMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageIncludeMacro" */ '../src/PageIncludeMacroRenderer.tsx'
			)
		).PageIncludeMacroRenderer,
});
